import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres3cu/mocker'

export default {
  getApiLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres3cu/columnsLabels')
  },
  getApiIndex (searchParams) {
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteopertst !== 'undefined' ? searchParams.dteopertst : ''),
        p_dteen: (typeof searchParams.dteoperten !== 'undefined' ? searchParams.dteoperten : ''),
        p_staappr: (typeof searchParams.staapprHres3cu !== 'undefined' ? searchParams.staapprHres3cu : 'D'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hres3cu/index', { params: sendParams })
  },
  getApiDetail (detailParams) {
    let searchParams = {
      p_numcom: detailParams.numcom
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_numcom
    return instance().get(endpoint + '/hres3cu/detail/' + params)
  },
  getApiDetailProcess (detailProcessParams) {
    let searchParams = {
      p_codempid: detailProcessParams.codempid,
      p_dtecompl: detailProcessParams.dtecompl,
      p_numcom: detailProcessParams.numcom,
      p_stacompl: detailProcessParams.stacompl
    }
    if (isMock) return generator(mocker.detailProcess())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtecompl.replace(/\//g, '') + '/' + searchParams.p_numcom + '/' + searchParams.p_stacompl
    return instance().get(endpoint + '/hres3cu/detailProcess/' + params)
  },
  getDetailProcessPopupCreate () {
    return generator(mocker.detailPopupProcessCreate())
  },
  getApiDetailProcessPopup (popupParams) {
    let searchParams = {
      p_codempid: popupParams.codempid,
      p_dtecompl: popupParams.dtecompl,
      p_numcom: popupParams.numcom,
      p_stacompl: popupParams.stacompl,
      p_dteopert: popupParams.dteopert,
      p_codopert: popupParams.codopert
    }
    if (isMock) return generator(mocker.detailPopupProcess())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtecompl.replace(/\//g, '') + '/' + searchParams.p_numcom + '/' + searchParams.p_stacompl + '/' + searchParams.p_dteopert.replace(/\//g, '') + '/' + searchParams.p_codopert
    return instance().get(endpoint + '/hres3cu/detailProcessPopup/' + params)
  },
  postApiDetailProcess ({ indexSelected, paramDetailProcess }) {
    let paramJson = {
      '0': {
        p_codempid: indexSelected.codempid,
        p_dtecompl: paramDetailProcess.dtecompl,
        p_numcom: indexSelected.numcom,
        p_stacompl: paramDetailProcess.stacompl,
        p_dteopert: paramDetailProcess.dteopert,
        p_codopert: paramDetailProcess.codopert,
        p_desopert: paramDetailProcess.desopert,
        p_limopert: paramDetailProcess.limopert,
        p_resopert: paramDetailProcess.resopert,
        p_dteres: paramDetailProcess.dteres,
        p_dteclose: paramDetailProcess.dteclose
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres3cu/save', sendParams)
  },
  deleteApiDetailProcess ({ param, indexSelected, dataRowsHasFlg }) {
    let params = {
      numcom: indexSelected.numcom
      // dteopert: param.dteopert,
      // codopert: param.codopert
    }
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], params)
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg),
      remarkApprove: '0',
      remarkReject: '0'
    }
    if (isMock) return generator(mocker.delete())
    return instance().post(endpoint + '/hres3cu/delete', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres3cu/index.js